"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.timezones = void 0;
exports.getDefaultTimezone = getDefaultTimezone;
const timezones_json_1 = __importDefault(require("./timezones.json"));
// Annotated rather than inferred, so the declaration carries the shape of one
// entry instead of the literal type of all 107.
exports.timezones = timezones_json_1.default;
function getDefaultTimezone() {
    const currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (currentTimezone) {
        const matchingTimezone = exports.timezones.find((timezone) => timezone.utc.includes(currentTimezone));
        if (matchingTimezone) {
            return matchingTimezone.utc[0];
        }
    }
    return '';
}
//# sourceMappingURL=index.js.map